<div
  class="flex flex-col md:flex-row gap-2 py-6 px-5 justify-between items-center md:items-start relative border rounded-xl border-[var(--color-neutral-300)]">

    <span
      class="hidden md:block absolute top-[2.75rem] border-t-2 border-[var(--color-neutral-300)]"
      [style.left.%]="lineInsetPercent"
      [style.right.%]="lineInsetPercent">
      <span [style.width]="progress" class="block -mt-[2px] border-t-2 border-[var(--color-primary-700)]"></span>
    </span>

  @for (step of steps; track step.slug) {
    <div
      class="w-full flex flex-row md:flex-col items-center gap-2 border-b md:border-0 border-[var(--color-neutral-200)]">

      <div
        [class.bg-[var(--color-neutral)]]="step.status !== 'done'"
        [class.bg-[var(--color-primary-700)]]="step.status === 'done'"
        [class.border-[var(--color-primary-700)]]="step.status === 'done' || step.status === 'in-progress'"
        [class.border]="step.status === 'done' || step.status === 'in-progress'"
        class="h-[2.5rem] w-[2.5rem] flex align-items-center justify-center rounded-full z-10">
        @if (step.status !== 'done') {
          <span
            [class.text-[var(--color-neutral-300)]]="step.status !== 'in-progress'"
            [class.text-[var(--color-primary-700)]]="step.status === 'in-progress'"
            class="cd-text-b2 mx-auto my-auto font-medium">{{ step.label }}</span>
        } @else {
          <img alt="Done" class="w-5 h-5 mx-auto my-auto filter-neutral" src="/assets/icons/feather/check.svg">
        }
      </div>

      <div
        [class.text-[var(--color-neutral-300)]]="step.status !== 'pending'"
        [class.text-[var(--color-neutral-600)]]="step.status === 'done'"
        [class.text-[var(--color-primary-600)]]="step.status === 'in-progress'"
        class="flex flex-col gap-1 pb-4 md:pb-0 items-center">
        <span class="cd-text-b2">{{ step.name }}</span>
        <span class="cd-text-b3 text-center">{{ step.description }}</span>
      </div>

    </div>
  }
</div>
